// src/components/Header/Header.jsx
// ============================================================
// En-tête global — design éditorial premium.
//   • Marque : LOGO de l'application (logo.png) + nom (Newsreader).
//   • Navigation : « Le Récit » (nouvelle expérience Va'a) + « À propos ».
//   • Langue : segmented control FR | EN (le segment actif glisse).
//   • Thème : switch à rail, soleil/lune visibles, curseur lumineux.
// S'efface pendant l'immersion. react-icons. Aucune chaîne en dur, zéro inline.
// NB : le lien « Le Récit » pointe pour l'instant vers /chapitre/humain (seul
//      chapitre Va'a monté). On le repointera vers /recit quand les 5
//      chapitres seront enchaînés. Le HERO de la Home n'est jamais touché.
// ============================================================

import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLang } from "../../store/context/langContext";
import { useJourney } from "../../store/context/journeyContext";
import logo from "../../logo.png";
import "./Header.scss";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const { immersive } = useJourney();
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  // Le hero de la Home est NOCTURNE : l'encre par défaut du header (sombre en
  // thème clair) y est illisible. On pose un modificateur, et LUI SEUL porte
  // l'encre claire — uniquement sur "/", et uniquement tant qu'on est encore
  // dans le hero (une fois défilé, le header reprend son apparence normale).
  // Aucune autre page n'est affectée.
  const onNightHero = pathname === "/" && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (immersive) return null;

  return (
    <header
      className={`header ${scrolled ? "header--scrolled" : ""} ${
        onNightHero ? "header--nighthero" : ""
      }`}
    >
      <div className="header__inner container">
        <Link to="/" className="header__brand" aria-label={t("brand")}>
          <img className="header__logo" src={logo} alt="" aria-hidden="true" />
          <span className="header__brand-stack">
            <span className="header__brand-text">{t("brand")}</span>
          </span>
        </Link>

        <div className="header__actions">
          {/* Navigation */}
          <nav className="header__nav" aria-label={t("brand")}>
            {/* Le lien « Le Récit » est retiré : on entre dans le récit par le
                bouton du hero, pas par le menu. La route /recit reste active. */}
            <NavLink
              to="/a-propos"
              className={({ isActive }) =>
                `header__navlink ${isActive ? "is-active" : ""}`
              }
            >
              {t("header.nav_about")}
            </NavLink>
          </nav>

          {/* Segmented control langue */}
          <div
            className={`langseg langseg--${lang}`}
            role="group"
            aria-label={t("header.lang")}
          >
            <span className="langseg__thumb" aria-hidden="true" />
            <button
              type="button"
              className={`langseg__opt ${lang === "fr" ? "is-on" : ""}`}
              onClick={() => setLang("fr")}
              aria-pressed={lang === "fr"}
            >
              FR
            </button>
            <button
              type="button"
              className={`langseg__opt ${lang === "en" ? "is-on" : ""}`}
              onClick={() => setLang("en")}
              aria-pressed={lang === "en"}
            >
              EN
            </button>
          </div>

          {/* Le switch de thème a été retiré : Datamoana se lit en sombre,
              point. Le récit est composé pour la nuit — laisser le choix
              revenait à proposer une version qui n'a jamais été réglée. */}
        </div>
      </div>
    </header>
  );
}